import script from "./BackToTopButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackToTopButton.vue?vue&type=script&setup=true&lang=ts"

import "./BackToTopButton.vue?vue&type=style&index=0&id=377d05a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377d05a4"]])

export default __exports__